import React, { useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import { getStudentIdData } from '../../../../lib/studentcollegelist'
import { addData, deleteIdData } from '../../../../lib/studentcollegelist'
import { getAllData } from '../../../../lib/collegerank'
import { useAuth } from '../../../../usercontext'

export default function InstructorStudentCollegeList() {
	const { slug } = useParams()

	const [collegelist, setCollegeList] = useState([])
	const [studentCollegeList, setStudentCollegeList] = useState([])
	const { profile } = useAuth()

	function getStudentData(colid) {
		if (studentCollegeList.length > 0) {
			const result = studentCollegeList.filter((item) => item.collegeId === colid)

			return result.length > 0 ? result[0].id : 0
		} else return 0
	}

	function getStudentCollege(colid) {
		if (studentCollegeList.length > 0) {
			const result = studentCollegeList.filter((item) => item.collegeId === colid)

			let returnresult = false

			if (result.length > 0) returnresult = result[0].isCheck

			return returnresult
		} else return false
	}

	async function UpdateisCheck(Id, isCheck, collegeId) {
		if (Id == 0) {
			await addData({
				isCheck: !isCheck,
				studentId: slug,
				collegeId: collegeId
			})
		} else {
			await deleteIdData(Id)
		}
		GetData()
	}

	function ChangeStatus(Id, isCheck, collegeId) {
		UpdateisCheck(Id, isCheck, collegeId)
	}

	async function GetData() {
		const colleges = await getAllData(slug)
		setCollegeList(colleges)

		const studentdata = await getStudentIdData(slug)
		setStudentCollegeList(studentdata)
	}

	useEffect(() => {
		GetData()
	}, [profile])

	return (
		<div className="col-12">
			<div className="settings-widget profile-details">
				<div className="settings-inner-blk p-0">
					<div className="profile-heading">
						<h3>College List</h3>
					</div>
					<div className="comman-space pb-0">
						<div className="settings-invoice-blk table-responsive">
							<table className="table table-hover">
								<thead>
									<tr>
										<th>Id</th>
										<th>College</th>
										<th>Is Check</th>
									</tr>
								</thead>
								<tbody>
									{collegelist.map(function (data) {
										return (
											<tr key={data.id}>
												<td>
													<Link to="#" className="invoice-no">
														{data.id}
													</Link>
												</td>
												<td>{data.collegename}</td>
												<td>
													<div className="form-check form-switch check-on">
														<input
															className="form-check-input"
															type="checkbox"
															checked={getStudentCollege(data.id)}
															onChange={(e) => ChangeStatus(getStudentData(data.id), getStudentCollege(data.id), data.id)}
														/>
													</div>
												</td>
											</tr>
										)
									})}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
